import { render, staticRenderFns } from "./StimulsoftViewer.vue?vue&type=template&id=96fab87c&scoped=true&"
import script from "./StimulsoftViewer.vue?vue&type=script&lang=ts&"
export * from "./StimulsoftViewer.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "96fab87c",
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VBtn } from 'vuetify/lib/components/VBtn';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VBtn,VRow})
